<wuc-line [noMarginTop]="true"></wuc-line>
<div class="wuc-slogan__container">
  <ng-content select="[slot='breadcrumbs']"></ng-content>
  <wuc-slogan class="wuc-slogan__text"></wuc-slogan>
</div>
<wuc-line [noMarginBottom]="true"></wuc-line>
